import { Inject, Injectable, Optional } from '@angular/core';

import type { AcceptedFileTypes, FileTypesCategoryEnum } from './accepted-file-types.types';
import { ACCEPTED_FILE_TYPES } from './accepted-file-types.types';

@Injectable({ providedIn: 'root' })
export class AcceptedFileTypesService {
  public readonly byCategoryAsString: Record<FileTypesCategoryEnum, string> = <
    Record<FileTypesCategoryEnum, string>
  >Object.fromEntries(
    Object.entries(this.acceptedFileTypes ?? {}).map(entry => [entry[0], entry[1].join(',')]),
  );
  constructor(
    @Optional() @Inject(ACCEPTED_FILE_TYPES) private acceptedFileTypes?: AcceptedFileTypes,
  ) {}

  public isInvalid(fileOrNameWithExtension: File | string, accept: string): boolean {
    const isString = typeof fileOrNameWithExtension === 'string';
    const nameWithExtension = isString ? fileOrNameWithExtension : fileOrNameWithExtension.name;

    if (!accept?.length || nameWithExtension.length === 0) {
      return false;
    }

    const fileExtension = nameWithExtension.split('.').pop()?.toLowerCase() ?? '';
    return fileExtension.length ? !accept.split(',').includes(`.${fileExtension}`) : true;
  }
}
